import APIManager from 'api/APIManager';
import APIConstant from 'api/APIConstant';
import { parameterToPath } from 'utils';

export type MemberShipGrade = {
  membership_grade_id?: number; // 등급내역 idx
  grade_id?: number; // 등급 idx
  user_id?: number; // 회원 idx
  grade_reason?: string; // 등급변경사유
  created_at?: number; // 생성일
  updated_at?: number; // 수정일
};

const $http = new APIManager();

const Api = {
  /**
   * [GETS] MemberShipGrade
   * --
   */
  getMemberShipGrades: async (params?: { [key: string]: string | number }) => {
    try {
      const res = await $http.get(APIConstant.GETS_MEMBERSHIP_GRADE, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [GET] MemberShipGrade
   * --
   */
  getMemberShipGrade: async (
    idx: number,
    params?: { [key: string]: string | number }
  ) => {
    try {
      const url = parameterToPath(APIConstant.GET_MEMBERSHIP_GRADE, {
        membership_grade_id: idx,
      });
      const res = await $http.get(url, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] MemberShipGrade
   * --
   */
  createMemberShipGrade: async (body: MemberShipGrade) => {
    try {
      const res = await $http.post(APIConstant.CREATE_MEMBERSHIP_GRADE, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [PUT] MemberShipGrade
   * --
   */
  updateMemberShipGrade: async (body: MemberShipGrade) => {
    try {
      const { membership_grade_id } = body;
      const url = parameterToPath(APIConstant.UPDATE_MEMBERSHIP_GRADE, {
        membership_grade_id: membership_grade_id,
      });

      const res = await $http.put(url, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [DELETE] MemberShipGrade
   * --
   */
  deleteMemberShipGrade: async (idx: number) => {
    try {
      const url = parameterToPath(APIConstant.UPDATE_MEMBERSHIP_GRADE, {
        membership_grade_id: idx,
      });

      const res = await $http.delete(url);

      return res;
    } catch (e) {
      throw e;
    }
  },
};

export default Api;
